/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import {
  Transfer,
  Button,
  message,
  Modal,
  Input,
  Switch,
  Row,
  Col,
  Form,
  Radio,
} from 'antd';
import {
  DmsTab,
  DataList,
  TableView,
  RegionCascader,
} from 'Components';
import {
  getGoodsList,
  getSecondChilds,
  secondCustomerAudit,
  deleteAddress,
  saveOrUpdateSecondaAdress,
  fetchCustomRightChannelList,
} from '../../service/customerManagement';
import {
  fetchChannelList,
} from '../../service/home';
import { getOrderList2 } from '../../service/order';
import { detail2 } from '../../service/channel';
import {
  optionsBtn,
  optionsRest,
} from '../../service/customerManagement/linkman';
import {
  openNotice,
  config,
} from '../../utils';
import { saveModules } from '../../service/people';
import { formatMoney } from 'Utils';

const confirm = Modal.confirm;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class ChannelDetail extends React.Component {
  constructor(props) {
    super(props);
    this.customerId = props.params.customerId;
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.isTG = /^(Admin|TG_SELLER|TG_SALE_DEPART|BM)$/.test(this.userData.roleCode); // 是否为天正内部员工
    this.state = {
      id: this.props.params.customerId,
      channelList: [],
      detail: {}, // 详情
      // start 子账号
      // start 子账号
      childAccountObj: {
        s: 10,
        p: 1,
        fatherId: this.customerId,
      },
      childAccountList: [],
      childAccountTotal: 0,
      empId: undefined, // 子账号id
      selectedChannel: [], // 选中的渠道
      selectedChannelKeys: [], // 选中的渠道key
      // end 子账号
      // start 收货地址
      filtered: false,
      filterDropdownVisible: false,
      visibleHarvestAddress: false,
      harvestAddressData: {
        accountId: null,
        id: null,
        cusId: this.customerId,
        purchaseName: '',
        recipientName: '',
        mobile: '',
        province: '',
        city: '',
        county: '',
        detailAddress: '',
      },
      harvestAddressObj: {
        s: 10,
        p: 1,
        cusId: this.customerId,
        q: '',
        source: '1',
      },
      harvestAddressList: [],
      harvestAddressTotal: 0,
      // end 收货地址
      // start 订单
      orderObj: {
        cusId: this.customerId,
        s: 10,
        p: 1,
      },
      orders: [],
      orderTotal: 0,
      // end 订单
      visibleAudit: false, // 审核弹框
      operationFlag: false, // 是否展示子账号及收货地址功能
      button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end') || '{}'), // 按钮权限
    };
    this.openMdoal = this.openMdoal.bind(this);
    this.goView = this.goView.bind(this);
    this.goBack = this.goBack.bind(this);
    this.getOrders = this.getOrders.bind(this);
    this.getChildAccount = this.getChildAccount.bind(this);
    this.getDetail = this.getDetail.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.auditFn = this.auditFn.bind(this);
  }

  goView(url) {
    hashHistory.push(url);
  }

  goBack() {
    hashHistory.goBack();
  }

  componentDidMount() {
    this.getDetail();
    this.getOrders();
    this.getHarvestAddress();
    this.getChildAccount();
    fetchChannelList().then(res => {
      if (res.status) {
        this.setState({
          channelList: (res.data || []).filter(x => !!x.id).map(x => ({ ...x, key: `${x.code}`, title: x.name })),
        });
      }
    });
  }

  // 二级客户详情
  getDetail() {
    const self = this;
    detail2(self.state.id).then(res => {
      self.setState({
        ...this.state,
        detail: res.data || {},
        operationFlag: res.data ? !!res.data.operationFlag : false
      });
      window.sessionStorage.setItem('customer_detail', JSON.stringify(res.data));
    });
  }

  // 订单列表
  getOrders() {
    const { orderObj } = this.state;
    getOrderList2(orderObj).then(res => {
      this.setState({
        ...this.state,
        orders: res.data,
        orderTotal: res.total,
      });
    });
  }

  // 收货地址列表
  getHarvestAddress() {
    const self = this;
    getGoodsList(this.state.harvestAddressObj).then(res => {
      self.setState({
        harvestAddressTotal: res.total || 0,
        harvestAddressList: res.data || [],
      });
      !res.status && openNotice('error', '操作失败', res.message || undefined);
    });
  };

  // 二级客户子账户列表
  getChildAccount() {
    const { childAccountObj } = this.state;
    getSecondChilds(childAccountObj).then(res => {
      this.setState({
        childAccountList: res.data,
        childAccountTotal: res.total,
      });
    });
  };

  // 列表翻页
  pageChange(page, pageSize, type) {
    //订单
    if (type === 'order') {
      this.setState({ orderObj: { ...this.state.orderObj, s: pageSize, p: page } }, () => {
        this.getOrders(this.state.orderObj);
      });
    }
    //收获地址
    if (type === 'address') {
      this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, () => {
        this.getHarvestAddress(this.state.searchObj);
      });
    }
    // 二级客户子账户
    if (type === 'childAccount') {
      this.setState({ childAccountObj: { ...this.state.childAccountObj, s: pageSize, p: page } }, function () {
        this.getChildAccount();
      });
    }
  }

  // 开通账号功能
  createAccount(ele) {
    const self = this;
    optionsBtn({ id: ele.id, name: ele.name, account: ele.account, status: 1 }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getChildAccount();
    });
  };

  // 子账户禁用账号功能
  // accountStatus 账号状态：0-禁用；1-启用；2-待审核
  // status 状态：0-离职；1-在职
  invalidAccount(ele) {
    const self = this;
    optionsBtn({ id: ele.id, name: ele.name, account: ele.account, status: ele.accountStatus === 1 ? 0 : 1 }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getChildAccount();
    });
  };

  // 子账户重置密码功能
  resetPwd(ele) {
    const self = this;
    optionsRest({ id: ele.id, name: ele.name, account: ele.account, plainPassword: 'TG123456' }).then(res => {
      if (!res.status) {
        message['error'](res.message);
      } else {
        openNotice('success', '重置成功，新密码为：TG123456');
      }
      res.status && self.getChildAccount();
    });
  };

  // 打开弹框
  openMdoal = (type, data) => {
    if (type === 'visibleHarvestAddress') {
      const { detail } = this.state;
      this.setState({
        visibleHarvestAddress: true,
        harvestAddressData: {
          accountId: data.accountId || detail.userId || null,
          id: data.id || null,
          cusId: this.customerId,
          purchaseName: data.purchaseName || detail.name || '',
          recipientName: data.recipientName || '',
          mobile: data.mobile || '',
          province: data.province || '',
          city: data.city || '',
          county: data.county || '',
          detailAddress: data.detailAddress || '',
          isDefault: data.isDefault === 1 ? true : undefined,
        },
      });
    }
    if (type === '设置渠道') {
      this.setState({
        visibleChildAccount: true,
        empId: data.id,
      });
      this.getRightCustomerChannel(data.id);
    }
    if(type === 'visibleAudit') {
      this.currentAccountInfo = data;
      this.setState({
        visibleAudit: true,
      }, () => {
        this.props.form.resetFields([
          'status',
          'auditOpinion',
          'auditRemark',
        ]);
      });
    }
  };

  // 关闭弹框
  closeMdoal = (key) => {
    this.setState({ [key]: false });
  };

  //弹框中已选择的渠道
  getRightCustomerChannel = (empId) => {
    fetchCustomRightChannelList({ empId: empId }).then(result => {
      if (result && result.code == 200) {
        this.setState({
          selectedChannel: (result.data || []).map(x => ({ ...x, key: `${x.code}`, title: x.name })), // 选中的渠道
          selectedChannelKeys: (result.data || []).map(x => `${x.code}`), // 选中的渠道key
        });
      } else {
        openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
      }
    });
  };

  // 选择渠道
  handleChannelChange = (targetKeys, direction, moveKeys) => {
    this.setState({ selectedChannelKeys: targetKeys });
  };

  // 完成选择渠道
  handleOk = (key) => {
    // 子账号设置渠道弹框
    if (key === 'visibleChildAccount') {
      this.closeMdoal(key);
      const { selectedChannelKeys, empId } = this.state;
      saveModules({ Itemselector: selectedChannelKeys, empId: empId }).then(result => {
        if (result && result.code == 200) {
          openNotice('success', '保存成功');
          this.getChildAccount();
        } else {
          openNotice('error', '保存失败', (result && result.message) ? result.message : '');
        }
      });
    }
    // 保存收货地址
    if (key === 'visibleHarvestAddress') {
      this.closeMdoal(key);
      this.saveAddress();
    }
    // 二级客户审核
    if (key === 'visibleAudit') {
      this.closeMdoal(key);
      this.auditFn();
    }
  };

  // 保存收货地址
  saveAddress() {
    const { harvestAddressData } = this.state;
    this.props.form.validateFields([
      'recipientName',
      'purchaseName',
      'mobile',
      'isDefault',
      'adminDiv',
      'detailAddress',
    ], (err, values) => {
      if (!err) {
        let params = {
          ...harvestAddressData,
          ...values,
          isDefault: values.isDefault === true ? 1 : 0,
        };
        if (values.adminDiv && values.adminDiv.selectedOptions) {
          const [province, city, county] = values.adminDiv.selectedOptions;
          params = {
            ...params,
            province: province.label,
            city: city.label,
            county: county.label,
          };
        }
        delete params.adminDiv;
        saveOrUpdateSecondaAdress(params).then(res => {
          res.status && this.getHarvestAddress();
          res.status && openNotice('success', '保存成功', res.message || undefined);
          !res.status && openNotice('error', '保存失败', res.message || undefined);
        });
      }
    });
  }

  // 删除收货地址
  deleteAddressFn(addressId) {
    deleteAddress(addressId).then(res => {
      res.status && this.getHarvestAddress();
      !res.status && openNotice('error', res.message);
    });
  }

  auditFn () {
    const self = this;
    this.props.form.validateFields([
      'status',
      'auditOpinion',
      'auditRemark',
    ], (err, values) => {
      if (!err) {
        let params = {
          ...values,
          id: self.currentAccountInfo.id,
          auditType: self.currentAccountInfo.auditType,// 1-二级客户；2-二级客户子账号
        };
        secondCustomerAudit(params).then(res => {
          res.status && self.getChildAccount();
          res.status && openNotice('success', '操作成功', res.message || undefined);
          !res.status && openNotice('error', '审核失败', res.message || undefined);
        });
      }
    });
  }

  render() {
    const self = this;
    const {
      detail, id, button_limits_end,
      orders, orderTotal, orderObj,
      harvestAddressObj, harvestAddressTotal, harvestAddressList, visibleHarvestAddress, harvestAddressData,
      childAccountTotal, childAccountObj, childAccountList, visibleChildAccount,
      visibleAudit, operationFlag,
    } = this.state;
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const cells = {
      sortName: {
        title: '客户简称',
      },
      phone: {
        title: '电话',
      },
      level: {
        title: '客户等级',
      },
      address: {
        title: '地址',
        render: text => `${detail.provinceText || ''}${detail.cityText || ''}${detail.countyText || ''}${text || ''}`,
      },
      createdName: {
        title: '创建人',
      },
      createdDate: {
        title: '创建时间',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----',
      },
      lastUpdatedDate: {
        title: '最后更新',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----',
      },
      remark: {
        title: '备注',
      },
      fileList: {
        title: '附件',
        render: arr => <span>
          {
            (arr || []).map((x, index, arrObj) => <span key={index}>
              <a key={index}
                 target="_blank"
                 href={`${config.server}${x.filePath}`}>{x.fileName}</a>{index < arrObj.length - 1 ? ',' : ''}&emsp;
            </span>)
          }
        </span>,
      },
    };
    // 订单
    const orderProps = {
      rowKey: 'id',
      loading: false,//更新表格数据中
      pageParam: {
        total: orderTotal,
        current: orderObj.p,//当前页码
        pageSize: orderObj.s,//当前分页数
        onChange: (page, pageSize) => this.pageChange(page, pageSize, 'order'),
      },
      columns: [
        {
          title: '订单编号',
          dataIndex: 'code',
          render: (text, record, index) => {
            return <a href={`#/thingsOrder/${record.id}`}>{text}</a>;
          },
        },
        {
          title: '订单类型',
          dataIndex: 'orderStatus',
          render: text => <span>{text == 0 ? '销售单' : (text == 1 ? '零售单' : '退货单')}</span>,
        },
        {
          title: '下单时间',
          dataIndex: 'createdDate',
          render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '',
        }, {
          title: '订单金额(元)',
          dataIndex: 'amount',
          render: text => <span style={{ color: '#d61518' }}>{'¥' + formatMoney(text)}</span>,
        }, {
          title: '订单整体折扣(%)',
          dataIndex: 'discountRate',
        }, {
          title: '实收金额',
          dataIndex: 'receivedAmount',
        }, {
          title: '订单状态',
          dataIndex: 'orderType',
          render: text => <span>{text == 1 ? '已登记' : '未登记'}</span>,
        }, {
          title: '备注',
          dataIndex: 'remark',
        }, {
          title: '操作员',
          dataIndex: 'operateName',
        },
      ],
      rows: orders,
    };
    // 子账号
    const childAccountProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total: childAccountTotal,
        current: childAccountObj.p,//当前页码
        pageSize: childAccountObj.s,//当前分页数
        onChange: (page, pageSize) => this.pageChange(page, pageSize, 'childAccount'),
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
        },
        {
          title: '性别',
          dataIndex: 'sex',
          render: (text, record, index) => {
            if (text === 0) return '女';
            if (text === 1) return '男';
            return '';
          },
        },
        {
          title: '手机',
          dataIndex: 'phone',
        },
        {
          title: '账户类别',
          dataIndex: 'roleName',
        },
        {
          title: '账号',
          dataIndex: 'account',
        },
        {
          title: '渠道权限',
          width: 200,
          dataIndex: 'channelList',
          render: (text) => {
            let str = '     ';
            if (text != null && text.length > 0) {
              text.forEach(x => {
                str += x.name + `; `;
              });
            }
            return str;
          },
        },
        {
          title: '账号状态',
          dataIndex: 'accountStatusText',
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: 160,
          render: (text, record, index) => {
            // accountStatus 账号状态：0-禁用；1-启用；2-待审核
            // status 状态：0-离职；1-在职
            return (<div>
              {button_limits_end.customer_detail_verify && record.accountStatus === 2 && this.isTG &&
              <span><a onClick={() => this.openMdoal('visibleAudit', {auditType: 2, id: record.userId})}>审核</a>&emsp;</span>}
              {button_limits_end.customer_detail_account_disable && record.accountStatus !== 2 &&
              <span><a onClick={self.invalidAccount.bind(self, record)}>{record.accountStatus === 0 ? '启用账号' : '禁用账号'}</a>&emsp;</span>}
              {button_limits_end.customer_detail_account_reset_password &&
              <span><a onClick={self.resetPwd.bind(self, record)}>重置密码</a>&emsp;</span>}
              {button_limits_end.customer_detail_account_set_channel &&
              <span><a onClick={self.openMdoal.bind(self, '设置渠道', record)}>设置渠道</a>&emsp;</span>}
              {button_limits_end.customer_detail_account_edit &&
              <a onClick={this.goView.bind(this, `/linkman/${self.customerId}/add/${record.id}?from=customer`)}>编辑账号</a>}
            </div>);
          },
        },
      ],
      rows: childAccountList,
    };
    // 收获地址
    const addressProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total: harvestAddressTotal,
        current: harvestAddressObj.p,//当前页码
        pageSize: harvestAddressObj.s,//当前分页数
        onChange: (page, pageSize) => this.pageChange(page, pageSize, 'address'),
      },
      columns: [
        {
          title: '收货人',
          dataIndex: 'recipientName',
          width: 200,
          render: (text, record) => (record.edit ?
            <Input value={text} onChange={(e) => {
              this.changeInput(e, record, 'recipientName');
            }} /> : text),
        },
        {
          title: '收货客户',
          dataIndex: 'purchaseName',
        },
        {
          title: '收件号码',
          dataIndex: 'mobile',
        },
        {
          title: '所在地区',
          dataIndex: 'province',
          render: (text, record, index) => `${record.province || ''}${record.city || ''}${record.county || ''}${record.detailAddress || ''}`,
        },
        {
          title: '默认',
          dataIndex: 'isDefault',
          key: 'isDefault',
          render: (text, record, index) => text ? '是' : '否',
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: 120,
          render: (text, record, index) => {
            return <div>
              {button_limits_end.customer_detail_address_add &&
              <a onClick={() => this.openMdoal('visibleHarvestAddress', record)}>修改</a>}
              {button_limits_end.customer_detail_address_add && <span>&emsp;&emsp;</span>}
              {button_limits_end.customer_detail_address_delete &&
              <a onClick={() => this.deleteAddressFn(record.id)}>删除</a>}
            </div>;
          },
        },
      ],
      rows: harvestAddressList,
    };
    // 收获地址弹框
    const addressModalProps = {
      visible: visibleHarvestAddress,
      title: '收货地址',
      width: '800px',
      maskClosable: false,
      onOk: () => this.handleOk('visibleHarvestAddress'),
      onCancel: () => this.closeMdoal('visibleHarvestAddress'),
    };
    // 子账号设置渠道弹框
    const channelModalProps = {
      visible: visibleChildAccount,
      title: '请选择要添加的渠道',
      width: '578px',
      maskClosable: false,
      onOk: () => this.handleOk('visibleChildAccount'),
      onCancel: () => this.closeMdoal('visibleChildAccount'),
    };
    // 二级客户审核弹框
    const auditModalProps = {
      visible: visibleAudit,
      title: '客户账号审核',
      width: '800px',
      maskClosable: false,
      onOk: () => this.handleOk('visibleAudit'),
      onCancel: () => this.closeMdoal('visibleAudit'),
    };
    return <div className="dms-main-box">
      <div>
        <DmsTab options={[`客户详情 -- ${detail.name || ''}`]} defaultKey={0}>
          {button_limits_end.customer_detail_01 &&
          <Button onClick={this.goView.bind(this, `/customer/add/${id}`)}>编辑</Button>}
          {(button_limits_end.customer_detail_verify && detail.accountStatus === 2 && this.isTG && detail.cusType === 'HIGH_CUS') &&
          <Button onClick={() => this.openMdoal('visibleAudit', {auditType: 1, id: detail.userId})}>审核</Button>}
          <Button onClick={this.goBack}>返回</Button>
        </DmsTab>
        <div className="dms-table-box">
          <DataList cells={cells} data={detail}></DataList>
        </div>
      </div>
      <DmsTab className="white-bg no-border" options={['订单详情']} defaultKey={0} />
      <div className="dms-table-box">
        <TableView {...orderProps} bordered pagination={false} />
      </div>

      {operationFlag && <div>
        <div className="dms-split-bar"></div>
        <DmsTab className="white-bg no-border" options={['收货地址']} defaultKey={0}>
          {button_limits_end.customer_detail_address_add && (
            <Button className="editable-add-btn" onClick={() => this.openMdoal('visibleHarvestAddress', {})}>新增</Button>
          )}
        </DmsTab>
        <div className="dms-table-box">
          <TableView {...addressProps} />
        </div>

        <div className="dms-split-bar"></div>
        <DmsTab className="white-bg no-border" options={['子账户']} defaultKey={0}>
          {button_limits_end.customer_detail_account_add && (
            <Button type="primary"
                    onClick={this.goView.bind(this, `/linkman/${detail.id}/add/0?from=customer`)}>新增子账号</Button>)}
        </DmsTab>
        <div className="dms-table-box">
          <TableView {...childAccountProps} />
        </div>
      </div>}

      <Modal {...channelModalProps}>
        <Transfer
          dataSource={this.state.channelList}
          listStyle={{
            width: 250,
            height: 300,
          }}
          targetKeys={this.state.selectedChannelKeys}
          onChange={this.handleChannelChange}
          render={item => item.title}
        />
      </Modal>

      <Modal {...addressModalProps}>
        <Row gutter={16}>
          <Col className="gutter-row" span={12}>
            <FormItem label="收货人" hasFeedback>
              {getFieldDecorator('recipientName', {
                initialValue: harvestAddressData.recipientName || '',
                rules: [
                  {
                    required: true,
                    message: '请输入收货人姓名',
                  },
                ],
              })(<Input placeholder="请输入收货人姓名" style={{ width: '100%' }} />)}
            </FormItem>
          </Col>
          <Col className="gutter-row" span={12}>
            <FormItem label="收货客户" hasFeedback>
              {getFieldDecorator('purchaseName', {
                initialValue: harvestAddressData.purchaseName || '',
                rules: [
                  {
                    required: true,
                    message: '请输入收货客户',
                  },
                ],
              })(<Input placeholder="请输入收货客户" style={{ width: '100%' }} />)}
            </FormItem>
          </Col>
          <Col className="gutter-row" span={12}>
            <FormItem label="收件号码" hasFeedback>
              {getFieldDecorator('mobile', {
                initialValue: harvestAddressData.mobile || '',
                rules: [
                  {
                    required: true,
                    message: '请输入收件号码',
                  },
                ],
              })(<Input placeholder="请输入收件号码" style={{ width: '100%' }} />)}
            </FormItem>
          </Col>
          <Col className="gutter-row" span={12}>
            <FormItem label="默认地址" hasFeedback>
              {getFieldDecorator('isDefault', {
                initialValue: harvestAddressData.isDefault || false,
                valuePropName: 'checked',
              })(<Switch />)}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16} id="adminDivBox">
          {!!harvestAddressData.id && harvestAddressData.province ? <FormItem label="地址：" hasFeedback>
            <Input disabled
                   value={`${harvestAddressData.province}${harvestAddressData.city}${harvestAddressData.county}`}
                   placeholder="请输入详细地址"
                   style={{ width: '100%' }} />
          </FormItem> : <FormItem label="地址：" hasFeedback>
            {getFieldDecorator('adminDiv', {
              initialValue: {
                province: harvestAddressData.province ? parseInt(harvestAddressData.province) : undefined,
                city: harvestAddressData.city ? parseInt(harvestAddressData.city) : undefined,
                county: harvestAddressData.county ? parseInt(harvestAddressData.county) : undefined,
              },
              rules: [
                {
                  required: true,
                  message: '请选择地址',
                },
              ],
              getValueFromEvent: (e) => {
                return e;
              },
            })(<RegionCascader containerId="adminDivBox" placeholder="请选择地址" style={{ width: '100%' }} />)}
          </FormItem>}
        </Row>
        <FormItem label={null} hasFeedback>
          {getFieldDecorator('detailAddress', {
            initialValue: harvestAddressData.detailAddress || '',
            rules: [
              {
                required: true,
                message: '请输入详细地址',
              },
            ],
          })(<Input placeholder="请输入详细地址" style={{ width: '100%' }} />)}
        </FormItem>
      </Modal>
      <Modal {...auditModalProps}>
        <Row gutter={16}>
          <Col className="gutter-row" span={12}>
            <FormItem label="审核意见">
              {getFieldDecorator('auditOpinion', {
                initialValue: '1',
                rules: [
                  {
                    required: true,
                    message: '请选择是否有效',
                  },
                ],
                getValueFromEvent: (e) => {
                  setFieldsValue({status: e === '1' ? '1' : '0'})
                  return e;
                }
              })(<RadioGroup>
                <Radio value='1'>同意</Radio>
                <Radio value="0">拒绝</Radio>
              </RadioGroup>)}
            </FormItem>
          </Col>
          <Col className="gutter-row hide" span={12}>
            <FormItem label="账号状态">
              {getFieldDecorator('status', {
                initialValue: '1',
                rules: [
                  {
                    required: true,
                    message: '请选择是否有效',
                  },
                ],
              })(<RadioGroup>
                <Radio value='0'>禁用</Radio>
                <Radio value="1">启用</Radio>
                <Radio value="2">待审核</Radio>
              </RadioGroup>)}
            </FormItem>
          </Col>
        </Row>
        <FormItem label="审核备注" hasFeedback>
          {getFieldDecorator('auditRemark', {
            initialValue: '',
            rules: [
              {
                required: false,
                message: '请输入审核备注',
              },
            ],
          })(<Input placeholder="请输入审核备注" style={{ width: '100%' }} />)}
        </FormItem>
      </Modal>
    </div>;
  }
}

export default Form.create()(ChannelDetail);



// WEBPACK FOOTER //
// ./src/routes/customer/detail.js